const carriers = {
  mondialRelay: "mondial_relay",
  colissimo: "colissimo",
  colisPrive: "colis_prive",
  deutschepost: "deutschepost",
  chronopost: "chronopost",
  dpd: "dpd",
};

export default carriers;
